// Sohbet etiketleri: metinde `@[Ünvan](contact:id)` / `#[Ürün](product:id)` biçiminde saklanır
export const TOKEN_RE = /([@#])\[([^\]]+)\]\((contact|product):([^)]+)\)/g;

export function parseMessage(text = "") {
  const out = [];
  const re = new RegExp(TOKEN_RE.source, "g");
  let last = 0;
  let m;
  while ((m = re.exec(text))) {
    if (m.index > last) out.push({ type: "text", value: text.slice(last, m.index) });
    out.push({ type: "mention", sigil: m[1], label: m[2], kind: m[3], id: m[4] });
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push({ type: "text", value: text.slice(last) });
  return out;
}

export const plainText = (text = "") => String(text || "").replace(TOKEN_RE, "$1$2");

export const cleanLabel = (s) => String(s || "").replace(/[[\]()]/g, "").trim();

// Ekranda görünen metin (@Ünvan / #Ürün) → saklanan token metni; yalnızca metinde hâlâ geçen etiketler döner
export function serializeMessage(display = "", mentions = []) {
  let out = display;
  const used = [];
  [...mentions].sort((a, b) => (b.label || "").length - (a.label || "").length).forEach((mn) => {
    const sigil = mn.type === "contact" ? "@" : "#";
    const needle = sigil + mn.label;
    if (mn.label && out.includes(needle)) {
      out = out.split(needle).join(`${sigil}[${mn.label}](${mn.type}:${mn.id})`);
      used.push({ type: mn.type, id: mn.id, label: mn.label });
    }
  });
  return { text: out, mentions: used };
}
